import { defineMessages } from 'react-intl';

export const scope = 'app.containers.ApplicantsV2';

export default defineMessages({
  chooseJob: {
    id: `${scope}.chooseJob`,
    defaultMessage: 'choose job',
  },
  locationOfJob: {
    id: `${scope}.locationOfJob`,
    defaultMessage: 'Post to Job Boards is not\navailable for this location.',
  },
  inactiveJob: {
    id: `${scope}.inactiveJob`,
    defaultMessage:
      'Post to Job Boards is not\navailable for inactive openings.',
  },
  remoteJob: {
    id: `${scope}.remoteJob`,
    defaultMessage: 'Post to Job Boards is not\navailable for remote openings.',
  },
  hireGoBadgeMessage: {
    id: `${scope}.badgeMessage`,
    defaultMessage: 'Hire Go enabled',
  },
  scorecardScoreHeaderInfo: {
    id: `${scope}.scorecardScoreHeaderInfo`,
    defaultMessage:
      'Average across every submitted scorecard on this applicant, from all stages. In-progress and comments-only scorecards are excluded.',
    description:
      'Tooltip on the information marker beside the Score column header in the applicant table',
  },
});
